import React from 'react';
import ReportViewer from './ReportViewer';

const ReportDisplay = ({ reportData, onNewReport, needsApproval = false }) => {
  return <ReportViewer reportData={reportData} onNewReport={onNewReport} needsApproval={needsApproval} />;
};

export default ReportDisplay;